import { combineReducers } from 'redux'

import list from './list/slice'

const applicationsReducer = combineReducers({
  list,
})

export default applicationsReducer
